var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ListForm',{class:`col-${_vm.item.size} ${_vm.item.class}`,style:(_vm.item.style),attrs:{"item":_vm.item,"items":_vm.item.children,"selectedItem":_vm.selectedItem,"listItems":_vm.listData,"prevSelectedItem":_vm.prevSelectedItem,"setSelectedItems":_vm.setSelectedItems,"topbarControls":_vm.topbarControls,"loading":_vm.loading}})
}
var staticRenderFns = []

export { render, staticRenderFns }